import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const MemoForParentsOfAFutureFirstGraderPage = () => {
  return (
    <Layout>
      <article>
        <h2>Пам&apos;ятка для батьків майбутнього першокласника</h2>

        <h3 className="top-spacing-big">ТЕСТ &quot;КРУГОЗІР&quot;</h3>

        <p>Запропонуйте дитині відповісти на запитання.</p>

        <ol>
          <li>Як тебе звуть? Як твоє прізвище?</li>
          <li>Як звуть твоїх тата і маму? Чи знаєш ти їхні імена по батькові?</li>
          <li>Назви свою домашню адресу.</li>
          <li>Скільки тобі років? Скільки буде через рік, два? Скільки років тобі було рік тому?</li>
          <li>Коли ми лягаємо спати?</li>
          <li>Коли прокидаємося?</li>
          <li>У який час ми обідаємо?</li>
          <li>Ким працюють твої тато і мама?</li>
          <li>Якого кольору ця ваза (книга, олівець, стіл і так далі)?</li>
          <li>Скільки всього пір року? Які пори року ти знаєш? Яка пора року зараз?</li>
          <li>Коли йде сніг? Коли збирають урожай? Коли цвітуть проліски? Коли буває дуже спекотно?</li>
          <li>Що роблять будівельник, продавець, перукар, кухар?</li>
          <li>Що залишається на землі після того, як пройде дощ?</li>
          <li>Що роблять діти у школі?</li>
          <li>Чи хочеш ти йти до школи?</li>
          <li>Покажи своє праве око, ліве вухо, ліву руку, праву ногу. Навіщо нам потрібні очі, вуха?</li>
          <li>Яких тварин ти знаєш?</li>
          <li>Яких птахів ти знаєш?</li>
          <li>Хто більший: слон чи лисиця?</li>
          <li>Що більше: 5 чи 3? Полічи від 4 до 10, від 10 до 1.</li>
          <li>Які геометричні фігури ти знаєш? Чим схожі коло й овал?</li>
        </ol>

        <p>
          Інформація про себе та свою родину: запитання <strong>1, 2, 3, 4, 5, 6, 7, 8</strong>. <br />
          Уявлення дитини про навколишній світ: запитання <strong>9, 10, 11, 12, 13, 17, 18</strong>. <br />
          Здатність аналізувати інформацію, міркувати: запитання <strong>20, 21</strong>. <br />
          Бажання вчитися: запитання <strong>14, 15</strong>.
        </p>

        <p>
          Оцінювання результатів: <br />
          <strong>Високий рівень</strong> – дитина відповіла на всі запитання й дала чіткі пояснення. <br />
          <strong>Середній рівень</strong> – дитина відповіла на більшість запитань без пояснень. <br />
          <strong>Низький рівень</strong> – дитина відповіла лише на декілька запитань і дала неправильні пояснення.
        </p>

        <h3 className="top-spacing-big">Що слід пам&apos;ятати батькам майбутнього першокласника</h3>

        <ul className="top-spacing-big">
          <li>Хваліть, хваліть і ще раз хваліть свою дитину за те, що вона робить.</li>
          <li>
            Розповідайте про школу, про те, що там роблять діти, як проходять уроки, про те, що в школі дуже цікаво.
          </li>
          <li>Розповідайте дитині про власний позитивний досвід.</li>
          <li>Допомагайте, але водночас привчайте малюка бути самостійним.</li>
          <li>Не виконуйте завдання за дитину, а краще підбадьорюйте і підтримуйте.</li>
          <li>Не критикуйте дитину, якщо в неї поки що не все виходить так, як хотілося б.</li>
          <li>Радійте разом з дитиною новим відкриттям.</li>
          <li>Не порівнюйте свою дитину з іншими дітьми.</li>
        </ul>

        <StaticImage
          className="image top-spacing-big"
          layout="constrained"
          height={500}
          formats={['auto', 'webp', 'avif']}
          src="../../images/memo-for-parents-of-a-future-first-grader-1.png"
          alt="Пам'ятка для батьків майбутнього першокласника"
        />

        <h3 className="top-spacing-big">Візьміть до уваги!</h3>
        <p className="top-spacing-big">
          За останні роки у дошкільників зросла кількість захворювань органів травлення, серцево-судинної системи,
          зафіксовано зниження гостроти зору. З початком навчаня в ослабленої або фізично незрілої дитини ці показники
          можуть істотно погіршитися.
        </p>
        <p>
          У 60% шестирічних дітей є порушення мовленнєвого розвитку, що утруднює їхнє навчання в школі. Щоб запобігти
          цьому, вислуховуйте дитину, не перебивайте її, давайте можливість висловлюватися, коректно виправляйте,
          залучайте до рефлексування власних станів і почуттів.
        </p>
        <h3 className="top-spacing-big">Візьміть до уваги!</h3>
        <p className="top-spacing-big">
          Дитину треба готувати до того, що далеко не завжди всі ролі у житті можуть бути цікавими чи даватися винятково
          за нашими бажаннями, інколи доводиться робити і те, що потрібно іншим, хоч воно і не входить у коло наших
          безпосередніх інтересів.
        </p>
        <p>
          Діти переймають і наслідують наш приклад спілкування, визначаючи для себе його особливості, фіксуючи межі та
          правила поводження, запам&apos;ятовуючи інтонації, тембр і висоту голосу тощо.
        </p>
        <p>
          На поведінці дитини негативно позначаються обіцянки, які не виконуються або постійно відтерміновуються (варто
          замислюватися, перш ніж щось обіцяти малюкові).
        </p>
        <h3 className="top-spacing-big">Візьміть до уваги!</h3>
        <p className="top-spacing-big">
          Психофізіологічні особливості шестирічних малят не дають змоги в повному обсязі сформувати в них вольову
          готовність до шкільного навчання, як у дітей семи років. Це треба враховувати, щоб не ставити перед малюком
          непосильних завдань.
        </p>
        <p>Тільки зі спостережень за дитиною можна робити висновок про сформованість у неї вольової готовності.</p>
        <p>
          Формування вольової готовності дошкільника залежить від його темпераменту; зважайте на це, пропонуючи йому ті
          чи інші завдання.
        </p>
        <p>Волю дитини слід формувати, ставлячи до неї сталі вимоги, які не змінюються спонтанно під дією емоцій.</p>
        <h3 className="top-spacing-big">Візьміть до уваги!</h3>
        <p className="top-spacing-big">
          Мотиваційну готовність дитини слід формувати через її усвідомлення того позитивного, що очікує на неї у школі,
          а не на погрозах та залякуванні.
        </p>
        <p>
          Підвищити мотивацію дитини до шкільного навчання допоможе приклад батьків та близьких людей (покажіть свої
          зошити, шкільні нагороди, відзнаки, розкажіть про позитивний досвід шкільного навчання).
        </p>
        <p>Привабливість для сина і доньки шкільного навчання можна підвищити, створивши портфоліо досягнень дитини.</p>
        <p>
          Формуванню позитивної мотивації сприяють позитивні словесні формули підтримки з боку вихователів та батьків
          (“Спробуй іще раз!”; “Нічого, не хвилюйся, в тебе все вийде!”; “В тебе вийшло краще, ніж минулого разу!...”)
        </p>
        <h3 className="top-spacing-big">Візьміть до уваги!</h3>
        <p className="top-spacing-big">
          Провідний в інтелектуальній готовності до школи — розвиток мовлення, а йому сприяє систематичне читання дитині
          книжок, обговорення ілюстрацій, репродукцій, повні відповіді на її запитання.
        </p>
        <p>
          Не залишайте поза увагою бажання дитини з чимось ознайомитись або чогось навчитися, допомагайте їй у цьому,
          станьте для неї товаришем у відкритті.
        </p>
        <p>
          Велику допомогу в розвитку інтелектуальної готовності дитини можуть надати дитячі журнали, особливо “Джміль”,
          кожна рубрика якого спонукає до розмірковувань, пробуджує уяву. (За журналом з малюком треба працювати,
          важливо запитувати в нього, що найбільше сподобалося в матеріалі, які завдання зацікавили, звернути увагу на
          інші цікавинки й завдання, розтлумачити незрозумілі місця).
        </p>
      </article>
    </Layout>
  );
};

export default MemoForParentsOfAFutureFirstGraderPage;

export const Head = () => <SEO title="Готуємось до школи!" />;
